import { useNavigate } from "react-router-dom";
import { Button } from "@volca/ui/components/ui/button";
import {
  findingName,
  findingSentence,
} from "@/profitability/review/finding-row";
import type { Finding } from "@/profitability/review/types";
import {
  profitabilityTemplatePath,
  EDIT_PARAM,
  profitabilityRulePath,
} from "@/profitability/routes";
import type { ReviewRule } from "@/profitability/settings/types";
import type { EditAgentState } from "./use-agent-nav";

export const EditRuleButton = ({
  reportId,
  rule,
  runId,
  finding,
}: {
  reportId: string;
  rule: Pick<ReviewRule, "id" | "label">;
  runId?: string | null;
  finding?: Finding;
}) => {
  const navigate = useNavigate();
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={() => {
        const period = finding?.run_id ?? runId;
        const params = new URLSearchParams({ [EDIT_PARAM]: "1" });
        if (period) params.set("period", period);
        const state: EditAgentState = {
          ruleContext: {
            id: rule.id,
            label: rule.label,
            href: profitabilityRulePath(reportId, rule.id, period),
            ...(finding
              ? {
                  example: {
                    name: findingName(finding) || "Flagged record",
                    flag: findingSentence(finding),
                    dataset: finding.dataset,
                    recordId: finding.record_id,
                  },
                }
              : {}),
          },
        };
        void navigate(`${profitabilityTemplatePath(reportId)}?${params}`, {
          state,
        });
      }}
    >
      {finding ? "Refine this rule" : "Edit with Volca"}
    </Button>
  );
};
